// @flow
/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

/**
 * Control By Share Permission component
 */

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { ASSIGNED_TYPE, COMPONENT_CONFIG, CONSTRAINTS } from 'logic/data/Izenda.SecurityRulesConstants';
import uiState from 'logic/Izenda.UiState';
import { isArray, isNil, get } from 'lodash/fp';

@connect()
export default class ControlBySharePermission extends Component {
  onChangeFromPopup = (value: any) => {
    this.props.data.addAccessors(value);
  };

  onChange = (value: any) => {
    this.props.data.updateAccessors(value);
  };

  render() {
    const props = this.props;
    const { data } = props;
    const componentInfo = get(data.userGroup, COMPONENT_CONFIG);

    if (isNil(componentInfo)) {
      return null;
    }

    const propsByType =
      data.userGroup === ASSIGNED_TYPE[2].value
        ? {
            validations: CONSTRAINTS.REQUIRED,
            onChangeFromPopup: this.onChangeFromPopup
          }
        : {
            validations: CONSTRAINTS.REQUIRED,
            onChangeFromPopup: this.onChangeFromPopup,
            roleOption: {
              tenantId: uiState.getTenantId()
            }
          };

    return (
      <componentInfo.component
        {...componentInfo.props}
        {...propsByType}
        field="accessor"
        group={data.tempId}
        value={data.accessorsInfo}
        onChange={this.onChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/SecurityRules/Izenda.ControlBySharePermission.jsx